import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.sambo');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-sambo',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.sambo/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.sambo-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow: hidden;
  background: #faf9f6;
}

.sambo-glow {
  position: absolute;
  z-index: -2;
  right: -240px;
  bottom: -350px;
  width: 820px;
  height: 820px;
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(245, 158, 11, 0.17) 0%, rgba(251, 191, 36, 0.06) 45%, transparent 70%);
  pointer-events: none;
}

.sambo-lines {
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.38;
  background-image: repeating-linear-gradient(135deg, transparent 0, transparent 72px, rgba(100, 116, 139, 0.08) 73px);
  mask-image: linear-gradient(110deg, black, transparent 76%);
  -webkit-mask-image: linear-gradient(110deg, black, transparent 76%);
  pointer-events: none;
}

.sambo-mark {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 13px;
  background: #d97706;
  box-shadow: 0 8px 28px rgba(217, 119, 6, 0.18);
  font-size: 15px;
  font-weight: 800;
}

.sambo-status {
  width: 7px;
  height: 7px;
  border-radius: 9999px;
  background: #f59e0b;
  animation: sambo-pulse 2.2s ease-out infinite;
}

.sambo-stage {
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(251, 191, 36, 0.12), transparent 67%);
}

.sambo-frame {
  position: absolute;
  border: 1px solid rgba(217, 119, 6, 0.18);
  transform: rotate(45deg);
}

.frame-outer {
  width: 77%;
  height: 77%;
  border-style: dashed;
  animation: sambo-spin 30s linear infinite;
}

.frame-middle {
  width: 53%;
  height: 53%;
  border-color: rgba(100, 116, 139, 0.16);
  animation: sambo-spin-reverse 22s linear infinite;
}

.sambo-core {
  display: grid;
  position: relative;
  z-index: 2;
  width: 112px;
  height: 112px;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  overflow: hidden;
  color: #1e293b;
  border: 1px solid rgba(217, 119, 6, 0.18);
  border-radius: 29px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 28px 65px rgba(71, 85, 105, 0.13), inset 0 1px 0 white;
  backdrop-filter: blur(16px);
}

.sambo-core span {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 800;
}

.sambo-core span + span {
  border-left: 1px solid rgba(217, 119, 6, 0.18);
}

.sambo-block {
  position: absolute;
  width: 15px;
  height: 15px;
  border: 3px solid #faf9f6;
  border-radius: 4px;
  background: #f59e0b;
  box-shadow: 0 8px 18px rgba(217, 119, 6, 0.28);
}

.block-one {
  top: 13%;
  right: 26%;
}

.block-two {
  right: 12%;
  bottom: 27%;
}

.block-three {
  bottom: 15%;
  left: 23%;
}

@keyframes sambo-pulse {
  70% {
    box-shadow: 0 0 0 9px rgba(245, 158, 11, 0);
  }
}
@keyframes sambo-spin {
  to {
    transform: rotate(405deg);
  }
}
@keyframes sambo-spin-reverse {
  to {
    transform: rotate(-315deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .sambo-status,
  .sambo-frame {
    animation: none;
  }
}`],
})
export class PageSamboComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigateHome(event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href('/');
    }
}

export default PageSamboComponent;